import './DirectIntegrationTable.scss';
import { Fragment, useEffect, useRef, useState } from 'react';
import {
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Tooltip,
  FormHelperText,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useMediaQuery,
  useTheme,
  TextField,
  InputAdornment
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
// import DownloadIcon from '../../assets/images/capabilities/download.svg';
// import InfoIcon from '../../assets/images/capabilities/information.svg';
import CloseIcon from '../../assets/images/capabilities/close.svg';
import ChevronDown from '../../assets/images/capabilities/chevron.png';
import ArrowIcon from '../../assets/images/capabilities/arrow.svg';
import SearchIcon from '../../assets/images/capabilities/search.svg';
import DownArrow from '../../assets/images/capabilities/chevronDown.svg';
import UpArrow from '../../assets/images/capabilities/chevronUp.svg';
import SupportIcon from '../../assets/images/capabilities/supported.svg';
import NotSupportedIcon from '../../assets/images/capabilities/notSupported.svg';
import InProgressIcon from '../../assets/images/capabilities/inProgress.svg';
import LimitedIcon from '../../assets/images/capabilities/limited.svg';
import PartnerSelection from './PartnerSelection';

const DirectIntegrationTable = ({ compPartner }) => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  // const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery('(max-width:1050px)');
  //const breakpointCheck = useMediaQuery('(max-width:1200px)');
  const selectRefs = [
    useRef<HTMLLIElement>(null),
    useRef<HTMLLIElement>(null),
    useRef<HTMLLIElement>(null)
  ];

  const textFieldRefs = [
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null)
  ];

  const firstMenuItemRefs = [
    useRef<HTMLLIElement>(null),
    useRef<HTMLLIElement>(null),
    useRef<HTMLLIElement>(null)
  ];
  const column = t('capabilities_direct_integration_1', {
    returnObjects: true
  });
  const columnTable = column[0].columns.split(',');
  const section = column[0].sections;
  const statusTranslations = column[0].status;

  const containerRef = useRef<HTMLTableElement>(null);
  const [sectionCount, setSectionCount] = useState(0);
  useEffect(() => {
    if (section.length) {
      setSectionCount(section.length);
    }
  }, [section]);
  const [activedropdown, setActiveDropdown] = useState<number | null>(null);
  const [openDropdown, setOpenDropdown] = useState([false, false, false]);
  const [isInfoBoxOpen, setIsInfoBoxOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [announcementMessage, setAnnouncementMessage] = useState<string | null>(
    null
  );
  const [expandedSubsections, setExpandedSubsections] = useState(() => {
    const initalState = {};
    section.forEach((sec, sectionIndex) => {
      sec.subsections.forEach((subsec, subsectionIndex) => {
        initalState[`${sectionIndex}-${subsectionIndex}`] = true;
      });
    });
    return initalState;
  });
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const [expandedFeaturess, setExpandedFeatures] = useState({});
  const [selectedPartner, setSelectedPartner] = useState({});
  const [resetPartner, setResetPartner] = useState<string | null>(null);
  const [selectedPartners, setSelectedPartners] = useState<any>([
    {
      partnerURL: '',
      partnerLogo: ''
    },
    {
      partnerURL: '',
      partnerLogo: ''
    },
    {
      partnerURL: '',
      partnerLogo: ''
    }
  ]);

  // const additionalInformation = data[0].footer[0].entries;
  //const columns = data[0].columns.split(',');
  //const quickLinks = data[0].footer[1];
  //const sections = data[0].sections;

  const announceTableUpdate = () => {
    setAnnouncementMessage(null);
    setTimeout(() => {
      setAnnouncementMessage(
        'Partners capability comparison table has been updated. Use your screen reader’s table navigation commands to explore the updated content.'
      );
    }, 1000);
  };

  const calculateAverageStatus = (features, selectedPartner, columnIndex) => {
    const partnerName =
      selectedPartners[columnIndex].partnerLogo ?? selectedPartner[columnIndex];

    if (!partnerName) return null;

    // const statuses = features
    //   .map((feature) => feature[partnerName])
    //   .filter((status) => status !== undefined);
    const statuses = features.flatMap((feature) => {
      const featureStatuses = feature[partnerName]
        ? [feature[partnerName]]
        : [];

      const subFeatureStatuses = feature['sub-features']
        ? feature['sub-features']
          .map((subFeature) => subFeature[partnerName])
          .filter((status) => status !== undefined)
        : [];
      return [...featureStatuses, ...subFeatureStatuses];
    });

    if (statuses.length === 0) return null;

    const allSupported = statuses.every(
      (status) => status === statusTranslations.supported
    );
    if (allSupported) {
      return statusTranslations.supported;
    }

    const hasInProgress = statuses.some(
      (status) =>
        status === statusTranslations.Limited ||
        status === statusTranslations.notSupported ||
        status === statusTranslations.inProgress
    );
    if (hasInProgress) {
      return statusTranslations.Limited;
    }
    return null;
  };

  const handlePartnerChange = (event, columnIndex) => {
    const partnerId = event.target.value;

    const partner = column[0].partners.find(
      (p) => p.id === parseInt(partnerId)
    );

    setSelectedPartner((prevState) => ({
      ...prevState,
      [columnIndex]: partner?.partner_name || null
    }));

    setSelectedPartners((prevState) => {
      const updated = [...prevState];
      updated[columnIndex].partnerLogo = partner?.partner_name || '';
      updated[columnIndex].partnerURL = partner?.image || '';
      return updated;
    });
    setActiveDropdown(columnIndex);
    announceTableUpdate();
  };

  const getFilteredPartners = (columnIndex, searchInput = '') => {
    const selectedValues = selectedPartners.map(
      (partner) => partner.partnerLogo
    );

    const partners = column[0]?.partners
      .filter(
        (partner) =>
          !selectedValues.includes(partner.partner_name) ||
          partner.partner_name === selectedPartners[columnIndex].partnerLogo
      )
      .sort((a, b) => a.partner_name.localeCompare(b.partner_name));

    if (searchInput) {
      return partners.filter((partner) =>
        partner.partner_name
          .toLowerCase()
          .includes(searchInput.trim().toLowerCase())
      );
    } else {
      return partners;
    }
  };

  const handlePartnerSelection = (partner: any, index: number) => {
    setSelectedPartners((prev) => {
      const updated = [...prev];
      if (partner === null) {
        updated[index].partnerURL = '';
        updated[index].partnerLogo = '';
      } else {
        updated[index].partnerURL = partner.name;
        updated[index].partnerLogo = partner.logo_name;
      }
      return updated;
    });
    announceTableUpdate();
    //setResetPartner(null);
  };

  const getStatusIcon = (status) => {
    const tooltipStyles = {
      tooltip: {
        backgroundColor: '#FFFFFF',
        color: '#000000',
        borderRadius: '16px',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0px',
        verticalAlignment: 'middle',
        //top: '5px',
        textAlign: 'center',
        padding: '10px',
        boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.15)'
      },
      arrow: {
        color: '#FFFFFF'
      }
    };
    switch (status) {
      case statusTranslations.supported:
        return (
          <Tooltip
            title={statusTranslations.supported}
            arrow
            componentsProps={{
              tooltip: { sx: tooltipStyles.tooltip },
              arrow: { sx: tooltipStyles.arrow }
            }}
          >
            <span
              tabIndex={-1}
            >
              <img
                src={SupportIcon}
                alt=""
                aria-hidden="true"
                className="status-icon"
              />
              <span className="sr-only">Supported</span>
            </span>
          </Tooltip>
        );
      case statusTranslations.notSupported:
        return (
          <Tooltip
            title={statusTranslations.notSupported}
            arrow
            componentsProps={{
              tooltip: { sx: tooltipStyles.tooltip },
              arrow: { sx: tooltipStyles.arrow }
            }}
          >
            <span
              tabIndex={-1}
            >
              <img
                src={NotSupportedIcon}
                alt=""
                aria-hidden="true"
                className="status-icon"
              />
              <span className="sr-only">Not Supported</span>
            </span>
          </Tooltip>
        );
      case statusTranslations.inProgress:
        return (
          <Tooltip
            title={statusTranslations.inProgress}
            arrow
            componentsProps={{
              tooltip: { sx: tooltipStyles.tooltip },
              arrow: { sx: tooltipStyles.arrow }
            }}
          >
            <span
              tabIndex={-1}
            >
              <img
                src={InProgressIcon}
                alt=""
                aria-hidden="true"
                className="status-icon"
              />
              <span className="sr-only">In progress</span>
            </span>
          </Tooltip>
        );
      case statusTranslations.Limited:
        return (
          <Tooltip
            title={statusTranslations.Limited}
            arrow
            componentsProps={{
              tooltip: { sx: tooltipStyles.tooltip },
              arrow: { sx: tooltipStyles.arrow }
            }}
          >
            <span
              tabIndex={-1}
            >
              <img
                src={LimitedIcon}
                alt=""
                aria-hidden="true"
                className="status-icon"
              />
              <span className="sr-only">Partial/Limited</span>
            </span>
          </Tooltip>
        );
      default:
        return null;
    }
  };

  const [isHeaderFixed, setIsHeaderFixed] = useState(false);
  const [dropdownOpenIndex, setDropdownOpenIndex] = useState<number | null>(null);

  const handleDropdownToggle = (index: number, isOpen: boolean) => {
    setOpenDropdown((prev) => {
      const newState = [...prev];
      newState[index] = isOpen;
      return newState;
    });
    const headerElement = headerRef.current;
    const theadRows = headerElement?.querySelectorAll('tr');
    const partnerSelectRow = theadRows && theadRows.length > 1 ? theadRows[1] as HTMLElement : null;
    const headerTabElement = headerTabRef.current;

    if (isOpen) {
      setDropdownOpenIndex(index);
      if (partnerSelectRow?.style.position !== 'fixed' && headerTabElement?.style.position !== 'fixed') {
        const scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.overflow = 'hidden';
        document.body.dataset.scrollY = scrollY.toString();
      }
      setTimeout(() => {
        textFieldRefs[index].current?.focus();
      }, 300);

      if (activedropdown === index) {
        setSelectedPartner({});
        setActiveDropdown(null);
      } else {
        setSelectedPartner({});
        setActiveDropdown(index);
      }
    } else {
      if (partnerSelectRow?.style.position !== 'fixed' && headerTabElement?.style.position !== 'fixed') {
        const scrollY = document.body.dataset.scrollY || '0';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.overflow = '';
        window.scrollTo(0, parseInt(scrollY));
      }
      setSearchTerm('');
      setActiveDropdown(null);
      setDropdownOpenIndex(null);
    }
  };

  // useEffect(() => {
  //   const handleClick = (event: MouseEvent) => {
  //     const target = event.target as HTMLElement;
  //     if (
  //       !target.closest('.native-select-root') &&
  //       !target.closest('.MuiSelect-root')
  //     ) {
  //       setSelectedPartner({});
  //     }
  //   };
  //   const tableElement = containerRef.current;
  //   if (tableElement) {
  //     tableElement.addEventListener('click', handleClick);
  //   }
  //   return () => {
  //     if (tableElement) {
  //       tableElement.removeEventListener('click', handleClick);
  //     }
  //   };
  // }, []);

  // const toggleInfoBox = () => {
  //   setIsInfoBoxOpen(true);
  // };

  const toggleCloseInfoBox = () => {
    setIsInfoBoxOpen((prevState) => !prevState);
  };

  const toggleExpandCollapse = () => {
    setIsExpanded((prevState) => !prevState);

    //update all subsection to expand/collapse
    const newExpandedState = {};
    section.forEach((sec, sectionIndex) => {
      sec.subsections.forEach((subsec, subsectionIndex) => {
        newExpandedState[`${sectionIndex}-${subsectionIndex}`] = !isExpanded;
      });
    });
    setExpandedSubsections(newExpandedState);
  };

  const handleAccordion = (descriptionId, subsectionId) => {
    const uniqueId = `${subsectionId}-${descriptionId}`;
    setExpandedDescriptions((prevState) => ({
      ...prevState,
      [uniqueId]: !prevState[uniqueId]
    }));
  };

  const handleFeatureAccordion = (featureId) => {
    setExpandedFeatures((prevState) => ({
      ...prevState,
      [featureId]: !prevState[featureId]
    }));
  };

  const handleSelect = (index) => {
    const partner = column[0]?.partners.find(
      (item) => item.partner_name === selectedPartners[index].partnerLogo
    );
    return partner ? partner.id.toString() : '';
  };

  // Remove this entire useEffect block:
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (
        !target.closest('.native-select-root') &&
        !target.closest('.MuiSelect-root')
      ) {
        setSelectedPartner({});
      }
    };
    const tableElement = containerRef.current;
    if (tableElement) {
      tableElement.addEventListener('click', handleClick);
    }
    return () => {
      if (tableElement) {
        tableElement.removeEventListener('click', handleClick);
      }
    };
  }, []);

  const headerRef = useRef<HTMLTableSectionElement>(null);
  const headerTabRef = useRef<HTMLTableSectionElement>(null);

  const calculateFinalTabHeight = () => {
    const getHeightAndMargin = (selector, marginType, isOffset) => {
      const element = document.querySelector(selector);
      if (!element) return 0;

      const height = element.getBoundingClientRect().height || 0;
      return height;
    };
    const headerHeight = getHeightAndMargin('.logo', 'marginTop', 'true');
    const discoverHeaderHeight = getHeightAndMargin('.discover-header', 'marginTop', 'true');
    const selectDropdownHeight = getHeightAndMargin('.selectDropdown', 'marginTop', 'true');
    const cssJ9cgnlHeight = getHeightAndMargin('.css-j9cgnl', 'marginBottom', 'true');
    const contentSpacingHeight = getHeightAndMargin('.content-spacing', 'marginBottom', 'true');

    const finalHeight =
      headerHeight +
      selectDropdownHeight +
      discoverHeaderHeight +
      cssJ9cgnlHeight +
      contentSpacingHeight +
      60;

    return finalHeight;

  }

  const calculateFinalHeight = () => {
    const getHeightAndMargin = (selector, marginType, isOffset) => {
      const element = document.querySelector(selector);
      if (!element) return 0;

      const offsetHeight = isOffset ? element.offsetHeight || 0 : 0;
      return offsetHeight;
    };

    const headerHeight = getHeightAndMargin('.header', 'marginTop', 'true');
    const menuBarHeight = getHeightAndMargin('.menuBarContainerDesktop', 'marginTop', 'true');
    const discoverHeaderHeight = getHeightAndMargin('.discover-header', 'marginTop', 'true');
    const cssAgne8fHeight = getHeightAndMargin('.css-agne8f', 'marginTop', 'true');
    const cssJ9cgnlHeight = getHeightAndMargin('.css-j9cgnl', 'marginBottom', 'true');
    const contentSpacingHeight = getHeightAndMargin('.content-spacing', 'marginBottom', 'true');

    const finalHeight =
      headerHeight +
      menuBarHeight +
      discoverHeaderHeight +
      cssAgne8fHeight +
      cssJ9cgnlHeight +
      contentSpacingHeight;

    return finalHeight;
  };

  useEffect(() => {
    const handleScroll = () => {
      if (!isTablet) {
        return;
      }
      const headerTabElement = headerTabRef.current;
      const appTabHeader = document.querySelector('.header') as HTMLElement;
      const collapseExpandElement = document.querySelector('.collapse-expand') as HTMLElement;

      const finalTabHeight = calculateFinalTabHeight();
      const tableTabElement = containerRef.current;

      const appTabHeaderHeight = appTabHeader?.getBoundingClientRect().height || 0;
      const theadTabHeight = headerTabElement?.getBoundingClientRect().height || 0;
      const collapseTabHeight = collapseExpandElement?.getBoundingClientRect().height || 0;

      // Create placeholder elements if they don't exist
      let headerPlaceholder = document.querySelector('.header-placeholder') as HTMLElement;
      let collapsePlaceholder = document.querySelector('.collapse-placeholder') as HTMLElement;

      if (!headerPlaceholder && headerTabElement) {
        headerPlaceholder = document.createElement('div');
        headerPlaceholder.className = 'header-placeholder';
        headerPlaceholder.style.height = `${theadTabHeight}px`;
        headerPlaceholder.style.width = '100%';

        tableTabElement?.insertBefore(headerPlaceholder, tableTabElement?.firstChild);
      }
      if (!collapsePlaceholder && collapseExpandElement) {
        collapsePlaceholder = document.createElement('div');
        collapsePlaceholder.className = 'collapse-placeholder';
        collapsePlaceholder.style.height = `${collapseExpandElement.getBoundingClientRect().height}px`;
        collapsePlaceholder.style.width = '100%';
        tableTabElement?.insertBefore(collapsePlaceholder, headerPlaceholder.nextSibling);
      }
      //condition for fixing header and second row
      if (headerTabElement && collapseExpandElement && tableTabElement) {

        const scrollY = window.scrollY;
        const tableTabBottom = tableTabElement?.getBoundingClientRect().bottom + scrollY;

        if (scrollY > finalTabHeight && scrollY + appTabHeaderHeight + theadTabHeight + collapseTabHeight < tableTabBottom - theadTabHeight + appTabHeaderHeight + collapseTabHeight) {

          const originalWidth = headerTabElement.getBoundingClientRect().width || 0;
          const collapseWidth = collapseExpandElement.getBoundingClientRect().width || 0;

          // Fix header
          headerTabElement.style.position = 'fixed';
          headerTabElement.style.top = `${appTabHeaderHeight}px`;
          headerTabElement.style.zIndex = '1';
          headerTabElement.style.width = `${originalWidth}px`;
          headerTabElement.style.backgroundColor = '#ffffff';


          // Fix collapse-expand element
          collapseExpandElement.style.position = 'fixed';
          collapseExpandElement.style.top = `${appTabHeaderHeight + theadTabHeight}px`;
          collapseExpandElement.style.zIndex = '1';
          collapseExpandElement.style.width = `${collapseWidth}px`;


          // Show placeholders
          if (headerPlaceholder) headerPlaceholder.style.display = 'block';
          if (collapsePlaceholder) collapsePlaceholder.style.display = 'block';

          if (!isHeaderFixed) {
            setIsHeaderFixed(true);
            //setHeaderTransition(false);
          }
        } else {
          headerTabElement.style.position = 'static';
          collapseExpandElement.style.position = 'static';



          // Hide placeholders instead of removing them
          if (headerPlaceholder) headerPlaceholder.style.display = 'none';
          if (collapsePlaceholder) collapsePlaceholder.style.display = 'none';

          if (isHeaderFixed) {
            setIsHeaderFixed(false);

            if (dropdownOpenIndex !== null) {
              handleDropdownToggle(dropdownOpenIndex, true);
            }
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      // Cleanup placeholders
      const headerPlaceholder = document.querySelector('.header-placeholder') as HTMLElement;
      const collapsePlaceholder = document.querySelector('.collapse-placeholder') as HTMLElement;
      if (headerPlaceholder) headerPlaceholder.remove();
      if (collapsePlaceholder) collapsePlaceholder.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHeaderFixed, dropdownOpenIndex]);

  useEffect(() => {
    const handleScroll = () => {
      const headerElement = headerRef.current;
      const tableElement = containerRef.current;
      if (!headerElement || !tableElement) return;

      // Select the second tr in thead (partner select row)
      const theadRows = headerElement?.querySelectorAll('tr');
      const partnerSelectRow = theadRows && theadRows.length > 1 ? theadRows[1] as HTMLElement : null;
      if (!partnerSelectRow) return;

      // Select the first tr in tbody (collapse/expand row)
      const tbodyRows = tableElement.querySelectorAll('tbody tr');
      const collapseExpandRow = tbodyRows[0] as HTMLElement;

      // For border radius and borderTop
      const firstThElement = partnerSelectRow?.querySelector('td,th') as HTMLElement;
      const lastThElement = partnerSelectRow?.querySelector('td:last-child,th:last-child') as HTMLElement;

      // Get column widths from the partner select row (second thead row)
      const columnWidths = Array.from(partnerSelectRow?.children || []).map(
        (cell: any) => cell.getBoundingClientRect().width
      );

      const finalHeight = calculateFinalHeight();
      const appHeader = document.querySelector('.header') as HTMLElement;
      const menuBar = document.querySelector('.menuBarContainerDesktop') as HTMLElement;
      const appHeaderHeight = (appHeader?.offsetHeight || 0) + (menuBar?.offsetHeight || 0);

      if (partnerSelectRow && collapseExpandRow) {
        const scrollY = window.scrollY;
        const tableBottom = tableElement.getBoundingClientRect().bottom + window.scrollY;
        const partnerSelectRowHeight = partnerSelectRow.offsetHeight || 0;

        // When to fix
        if (
          scrollY > finalHeight &&
          scrollY + appHeaderHeight + partnerSelectRowHeight <
          tableBottom - partnerSelectRowHeight
        ) {
          // Set widths for sticky columns
          Array.from(partnerSelectRow.children).forEach((cell: any, idx) => {
            cell.style.width = `${columnWidths[idx]}px`;
            cell.style.maxWidth = `${columnWidths[idx]}px`;
            cell.style.minWidth = `${columnWidths[idx]}px`;
            cell.style.overflow = 'hidden';
            cell.style.textOverflow = 'ellipsis';
            cell.style.whiteSpace = 'nowrap';
          });
          Array.from(collapseExpandRow.children).forEach((cell: any, idx) => {
            cell.style.width = `${columnWidths[idx]}px`;
            cell.style.maxWidth = `${columnWidths[idx]}px`;
            cell.style.minWidth = `${columnWidths[idx]}px`;
          });

          // Fix partner select row (second thead row)
          partnerSelectRow.style.position = 'fixed';
          partnerSelectRow.style.top = `${appHeaderHeight}px`;
          partnerSelectRow.style.zIndex = '1';
          partnerSelectRow.style.backgroundColor = '#ffffff';

          // Add requested styles
          partnerSelectRow.style.borderTop = '0.5px solid #c9cacc';
          if (firstThElement) firstThElement.style.borderRadius = '0';
          if (lastThElement) lastThElement.style.borderRadius = '0';

          // Fix collapse/expand row just below partner select row
          collapseExpandRow.style.position = 'fixed';
          collapseExpandRow.style.top = `${appHeaderHeight + partnerSelectRowHeight}px`;
          collapseExpandRow.style.zIndex = '1';
          collapseExpandRow.style.backgroundColor = '#ffffff';

          if (!isHeaderFixed) setIsHeaderFixed(true);
        } else {
          // Reset styles
          partnerSelectRow.style.position = 'static';
          partnerSelectRow.style.top = '';
          partnerSelectRow.style.zIndex = '';
          partnerSelectRow.style.backgroundColor = '';
          partnerSelectRow.style.width = '';
          Array.from(partnerSelectRow.children).forEach((cell: any) => {
            cell.style.width = '';
          });

          collapseExpandRow.style.position = 'static';
          collapseExpandRow.style.top = '';
          collapseExpandRow.style.zIndex = '';
          collapseExpandRow.style.backgroundColor = '';
          collapseExpandRow.style.width = '';
          Array.from(collapseExpandRow.children).forEach((cell: any) => {
            cell.style.width = '';
          });

          // Reset requested styles
          partnerSelectRow.style.borderTop = '';
          if (firstThElement) firstThElement.style.borderRadius = '';
          if (lastThElement) lastThElement.style.borderRadius = '';

          if (isHeaderFixed) {
            setIsHeaderFixed(false);
            if (dropdownOpenIndex !== null) {
              handleDropdownToggle(dropdownOpenIndex, true);
            }
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHeaderFixed, dropdownOpenIndex]);

  const [highlightedIndex, setHighlightedIndex] = useState<number[]>([-1, -1, -1]);

  // Enhanced keyboard handler for W3C compliance
  const handleSelectKeyDown = (e: React.KeyboardEvent, index: number) => {
    const filteredPartners = getFilteredPartners(index, searchTerm);
    const isOpen = openDropdown[index];

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        if (e.altKey || !isOpen) {
          // Alt + Down Arrow opens the dropdown (W3C requirement)
          handleDropdownToggle(index, true);
          setHighlightedIndex(prev => {
            const newState = [...prev];
            newState[index] = 0;
            return newState;
          });
        } else if (isOpen) {
          // Navigate down in dropdown
          setHighlightedIndex(prev => {
            const newState = [...prev];
            newState[index] = Math.min(prev[index] + 1, filteredPartners.length - 1);
            return newState;
          });
        }
        break;

      case 'ArrowUp':
        e.preventDefault();
        if (isOpen) {
          setHighlightedIndex(prev => {
            const newState = [...prev];
            newState[index] = Math.max(prev[index] - 1, 0);
            return newState;
          });
        }
        break;

      case 'Enter':
        e.preventDefault();
        if (isOpen && highlightedIndex[index] >= 0 && filteredPartners[highlightedIndex[index]]) {
          const selectedPartner = filteredPartners[highlightedIndex[index]];
          handlePartnerChange({ target: { value: selectedPartner.id } }, index);
          handleDropdownToggle(index, false);
        }
        break;

      case 'Escape':
        e.preventDefault();
        if (isOpen) {
          handleDropdownToggle(index, false);
          // Reset search term without applying changes
          setSearchTerm('');
          setHighlightedIndex(prev => {
            const newState = [...prev];
            newState[index] = -1;
            return newState;
          });
        }
        break;

      case 'Tab':
        if (isOpen) {
          // Auto-select highlighted item on Tab (W3C requirement)
          if (highlightedIndex[index] >= 0 && filteredPartners[highlightedIndex[index]]) {
            const selectedPartner = filteredPartners[highlightedIndex[index]];
            handlePartnerChange({ target: { value: selectedPartner.id } }, index);
          }
          handleDropdownToggle(index, false);
        }
        break;

      default:
        // Allow typing for search functionality
        if (e.key.length === 1) {
          if (!isOpen) {
            handleDropdownToggle(index, true);
          }
        }
        break;
    }
  };

  // Enhanced text field keyboard handler
  const handleTextFieldKeyDown = (e: React.KeyboardEvent, index: number) => {
    const filteredPartners = getFilteredPartners(index, searchTerm);

    // Add this block before the switch
    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      // Focus last MenuItem
      if(filteredPartners.length>0){
              firstMenuItemRefs[index].current?.focus();
            }
      return;
    }

    switch (e.key) {
      case 'Escape':
        e.preventDefault();
        handleDropdownToggle(index, false);
        setSearchTerm('');
        setHighlightedIndex(prev => {
          const newState = [...prev];
          newState[index] = -1;
          return newState;
        });
        break;

      case 'Enter':
        e.preventDefault();
        if (highlightedIndex[index] >= 0 && filteredPartners[highlightedIndex[index]]) {
          const selectedPartner = filteredPartners[highlightedIndex[index]];
          handlePartnerChange({ target: { value: selectedPartner.id } }, index);
          handleDropdownToggle(index, false);
        } else if (filteredPartners.length > 0) {
          // Select first item if no item is highlighted
          const selectedPartner = filteredPartners[0];
          handlePartnerChange({ target: { value: selectedPartner.id } }, index);
          handleDropdownToggle(index, false);
        }
        break;

      case 'ArrowDown':
        e.preventDefault();
        setHighlightedIndex(prev => {
          const newState = [...prev];
          newState[index] = Math.min((prev[index] >= 0 ? prev[index] : -1) + 1, filteredPartners.length - 1);
          return newState;
        });
        setTimeout(() => {
          if (filteredPartners.length > 0) {
            firstMenuItemRefs[index].current?.focus();
          }
        }, 100);
        break;

      case 'ArrowUp':
        e.preventDefault();
        setHighlightedIndex(prev => {
          const newState = [...prev];
          newState[index] = Math.max(prev[index] - 1, 0);
          return newState;
        });
        break;
        
      default:
        e.stopPropagation();
        break;
    }
  };

  // Enhanced menu item hover handler
  const handleMenuItemHover = (partnerIndex: number, index: number) => {
    setHighlightedIndex(prev => {
      const newState = [...prev];
      newState[index] = partnerIndex;
      return newState;
    });
  };

  const renderTabletTable = () => {
    return (
      <div
        ref={containerRef}
        className="direct-integration-table-mobile"
        aria-label="Partners Capability Comparison"
        role="table"
      >
        <div
          ref={headerTabRef}
          role="rowgroup"
          style={{
            display: 'grid',
            gridTemplateColumns: '33.33% 33.33% 33.33%'
          }}
        >
          {columnTable.map((header, index) => {
            if (index === 0) return null;
            return (
              <div key={index} className="table-header" role="columnheader">
                <div className="header-content" role="cell">
                  {index === 0 ? null : selectedPartners[index - 1]
                    .partnerURL ? (
                    compPartner.find(
                      (partner) =>
                        partner.name === selectedPartners[index - 1].partnerURL
                    )?.isText ? (
                      <span style={{ fontSize: isMobile ? '70%' : '100%' }}>
                        {selectedPartners[index - 1].partnerURL}
                      </span>
                    ) : (
                      <span
                        aria-label={selectedPartners[index - 1].partnerLogo}
                        style={{ display: 'flex', justifyContent: 'center' }}
                      >
                        <img
                          src={
                            compPartner.find(
                              (partner) =>
                                partner.name ===
                                selectedPartners[index - 1].partnerURL
                            )?.name
                          }
                          alt={selectedPartners[index - 1].partnerURL}
                          className="partner-image"
                          aria-hidden="true"
                        />
                      </span>
                    )
                  ) : (
                    header
                  )}
                </div>
                {index > 0 && (
                  <button
                    type="button"
                    className="close-icon"
                    aria-label={`Remove partner ${selectedPartners[index - 1].partnerLogo
                      }`}
                    onClick={() => {
                      const updatedPartners = [...selectedPartners];
                      const partnerToRemove =
                        updatedPartners[index - 1].partnerURL;
                      updatedPartners[index - 1].partnerURL = '';
                      updatedPartners[index - 1].partnerLogo = '';
                      setSelectedPartners(updatedPartners);
                      setResetPartner(partnerToRemove);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        const updatedPartners = [...selectedPartners];
                        const partnerToRemove =
                          updatedPartners[index - 1].partnerURL;
                        updatedPartners[index - 1].partnerURL = '';
                        updatedPartners[index - 1].partnerLogo = '';
                        setSelectedPartners(updatedPartners);
                        setResetPartner(partnerToRemove);
                      }
                    }}
                  >
                    <img src={CloseIcon} alt="" aria-hidden="true" />
                  </button>
                )}
              </div>
            );
          })}
          {Array.from({ length: 3 }).map((_, index) => (
            <div className="body-section" role="columnheader" key={index}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
                role="cell"
              >
                <FormControl fullWidth>
                  <div
                    className={`native-select-root ${selectedPartner[index] ? 'has-selection' : ''
                      }`}
                  // tabIndex={0}
                  >
                    <div className="search-select-container">
                      <Select
                        autoComplete="off"
                        variant="standard"
                        inputProps={{
                          'aria-label': `Select partner for column ${index + 1}`
                        }}
                        ref={selectRefs[index]}
                        displayEmpty
                        value={
                          selectedPartners[index].partnerLogo
                            ? handleSelect(index)
                            : ''
                        }
                        onChange={(event) => {
                          if (event.target.value !== undefined) {
                            handlePartnerChange(event, index);
                            handleDropdownToggle(index, false);
                          }
                        }}
                        onKeyDown={(e) => {
                          const allowedKeys = [
                            'ArrowUp',
                            'ArrowDown',
                            'ArrowLeft',
                            'ArrowRight',
                            'Tab',
                            'Enter',
                            'Escape'
                          ];
                          if (!allowedKeys.includes(e.key)) {
                            e.preventDefault();
                          }
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            const target = e.target as HTMLSelectElement;
                            const selectedValue = target.value;
                            handlePartnerChange(
                              { target: { value: selectedValue } },
                              index
                            );
                          }
                        }}
                        open={openDropdown[index]}
                        onClose={() => {
                          handleDropdownToggle(index, false);
                          setSearchTerm('');
                        }}
                        onOpen={() => {
                          handleDropdownToggle(index, true);
                        }}
                        sx={{
                          width: '100%',
                          '.MuiSelect-root .MuiInputBase-root': {
                            width: '100% !important'
                          },
                          // position:'relative'
                          '& .MuiSelect-icon': {
                            display: 'none'
                          },
                          '&:before': {
                            borderBottom: 'none'
                          },
                          '&:after': {
                            borderBottom: 'none'
                          },
                          '&:hover:not(.Mui-disabled):before': {
                            borderBottom: 'none'
                          },
                          '& .MuiSelect-select': {
                            backgroundColor: 'transparent !important'
                          },
                          '& .MuiMenu-list, & .MuiList-padding': {
                            paddingTop: '0px'
                          }
                        }}
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row'
                                }}
                                tabIndex={0}
                              >
                                <img
                                  src={SearchIcon}
                                  alt="search icon"
                                  className="search-icon"
                                  aria-hidden="true"
                                />
                                <div
                                  style={{
                                    position: 'relative',
                                    bottom: '-4px',
                                    marginLeft: '10px',
                                    fontWeight: 600,
                                    fontSize: '15px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    width: isMobile ? '25px' : '100%'
                                  }}
                                >
                                  Select
                                </div>
                              </div>
                            );
                          }
                          return (
                            <div
                              style={{ display: 'flex', flexDirection: 'row' }}
                              tabIndex={0}
                            >
                              <img
                                src={SearchIcon}
                                alt="search icon"
                                className="search-icon"
                                aria-hidden="true"
                              />
                              <div
                                style={{
                                  position: 'relative',
                                  bottom: '-4px',
                                  marginLeft: '10px',
                                  fontWeight: 600,
                                  fontSize: '15px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  width: isMobile ? '25px' : '100%'
                                }}
                              >
                                {selectedPartners[index].partnerLogo}
                              </div>
                            </div>
                          );
                        }}
                        MenuProps={{
                          // disablePortal: true,

                          disableScrollLock: true,
                          anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'left'
                          },
                          transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left'
                          },
                          PaperProps: {
                            sx: {
                              '&::-webkit-scrollbar': {
                                display: 'none'
                              },
                              msOverflowStyle: 'none', // IE and Edge
                              scrollbarWidth: 'none', // Firefox
                              '& .MuiMenu-list, & .MuiList-padding': {
                                paddingTop: '0px',
                                paddingBottom: '0px'
                              }
                            },
                            style: {
                              maxHeight: 260,
                              overflowY: 'auto',
                              width: '350px',
                              borderRadius: '14px 14px 14px 14px',
                              paddingTop: '0px'
                            }
                          }
                        }}
                      >
                        <div
                          style={{
                            padding: '30px',
                            backgroundColor: '#F1F7FB',
                            borderBottom: '1px solid #1460AA',
                            top: '0px',
                            zIndex: 1,
                            position: 'sticky'
                          }}
                        >
                          <TextField
                            id="input-with-icon-textfield"
                            variant="standard"
                            value={searchTerm}
                            helperText={column[0].helperText_1}
                            aria-label={`Search partner for column ${index + 1
                              }`}
                            inputRef={textFieldRefs[index]}
                            sx={{
                              width: '100%',
                              '& input': {
                                fontSize: '16px',
                                fontWeight: 600,
                                marginBottom: '7px'
                              }
                            }}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === 'Escape') {
                                e.preventDefault();
                                handleDropdownToggle(index, false);
                              }
                              if (e.key === 'Enter' || e.key === 'ArrowDown') {
                                e.preventDefault();
                                setTimeout(() => {
                                  firstMenuItemRefs[index].current?.focus();
                                }, 100); // Wait for dropdown to render
                              } else {
                                e.stopPropagation();
                              }
                            }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <img
                                    src={SearchIcon}
                                    alt="search icon"
                                    // className="search-icon"
                                    aria-hidden="true"
                                    style={{
                                      width: '25px',
                                      height: '25px',
                                      margin: '0px 10px 10px 0px'
                                    }}
                                  />
                                </InputAdornment>
                              )
                            }}
                          />
                        </div>
                        {getFilteredPartners(index, searchTerm).map(
                          (partner, partnerIndex) => (
                            <MenuItem
                              className="dropdown-section"
                              key={partnerIndex}
                              value={partner.id}
                              ref={
                                partnerIndex === 0
                                  ? firstMenuItemRefs[index]
                                  : null
                              }
                              onKeyDown={
                                partnerIndex === 0
                                  ? (e) => {
                                    if (e.key === 'ArrowUp') {
                                      e.preventDefault();

                                      textFieldRefs[index].current?.focus();
                                    }
                                  }
                                  : undefined
                              }
                              tabIndex={-1} // Ensure it's focusable
                              aria-selected={
                                selectedPartners[index].partnerLogo
                                  ? handleSelect(index) ===
                                  partner.id.toString()
                                  : false
                              }
                              sx={{
                                height: '50px',
                                '&.Mui-selected': {
                                  backgroundColor: '#EFF0F2'
                                }
                              }}
                            >
                              {partner.partner_name}
                            </MenuItem>
                          )
                        )}
                      </Select>
                    </div>
                    <div>
                      <img
                        className="arrow-icon"
                        src={ArrowIcon}
                        alt=""
                        aria-hidden="true"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleDropdownToggle(index, true)}
                      />
                    </div>
                  </div>
                  <FormHelperText className="custom-helper-text">
                    {selectedPartner[index] ||
                      selectedPartners[index].partnerLogo ? (
                      <span> {column[0].helperText_1} </span>
                    ) : (
                      <span> {column[0].helperText_2} </span>
                    )}
                  </FormHelperText>
                </FormControl>
              </div>
            </div>
          ))}
        </div>
        <div
          className="collapse-expand"
          style={{
            width: '100%',
            backgroundColor: '#F1F7FB',
            padding: '25px 0px 25px 5px'
          }}
          role="rowgroup"
        >
          <button
            className="expand-collapse-container"
            onClick={toggleExpandCollapse}
            aria-expanded={isExpanded}
            aria-label={isExpanded ? 'Collapse all' : 'Expand all'}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleExpandCollapse();
              }
            }}
          >
            <span>{isExpanded ? column[0].collapse : column[0].expand}</span>
            <img
              src={ChevronDown}
              alt={isExpanded ? 'Collapse all' : 'Expand all'}
              className="arrow-icon"
              aria-hidden="true"
            />
          </button>
        </div>
        <div role="rowgroup">
          {section.map((section, sectionIndex) => (
            <Fragment key={sectionIndex}>
              <div
                className="section-head"
                id={`section-${sectionIndex}`}
                role="row"
                aria-label={`${section.title} Capabilities`}
              >
                {section.title}
              </div>

              <div className="custom-subsection" role="rowgroup">
                {section.subsections.map((subsection, subsectionIndex) => (
                  <div role="row" key={subsectionIndex}>
                    <Accordion
                      role="button"
                      key={subsectionIndex}
                      expanded={
                        expandedSubsections[
                        `${sectionIndex}-${subsectionIndex}`
                        ] || false
                      }
                      onChange={() =>
                        setExpandedSubsections((prevState) => ({
                          ...prevState,
                          [`${sectionIndex}-${subsectionIndex}`]:
                            !prevState[`${sectionIndex}-${subsectionIndex}`]
                        }))
                      }
                      aria-controls={`panel${subsectionIndex}-content`}
                      id={`panel${subsectionIndex}-header`}
                      aria-expanded={
                        expandedSubsections[
                        `${sectionIndex}-${subsectionIndex}`
                        ] || false
                      }
                      sx={{
                        backgroundColor: expandedSubsections[
                          `${sectionIndex}-${subsectionIndex}`
                        ]
                          ? '#f1f7fa'
                          : '#f1f7fa',
                        borderBottom:
                          section.subsections.length - 1 === subsectionIndex
                            ? 'none'
                            : '1px solid #C9CACC',
                        boxShadow: 'none',
                        '&.Mui-expanded': {
                          padding: 0,
                          margin: 0
                        },
                        '&:last-child': {
                          borderBottomRightRadius:
                            section.subsections.length - 1 ===
                              subsectionIndex &&
                              sectionIndex === sectionCount - 1
                              ? '16px'
                              : '0px',
                          borderBottomLeftRadius:
                            section.subsections.length - 1 ===
                              subsectionIndex &&
                              sectionIndex === sectionCount - 1
                              ? '16px'
                              : '0px'
                          // borderBottomRightRadius: '16px',
                          // borderBottomLeftRadius: '16px'
                        }
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <img
                            src={DownArrow}
                            alt="Expand subsection"
                            className="custom-accordion-icon"
                          />
                        }
                        aria-label={`${subsection.tittle} Functionality`}
                        aria-controls={`panel${subsectionIndex}-content`}
                        id={`panel${subsectionIndex}-header`}
                        aria-expanded={
                          expandedSubsections[
                          `${sectionIndex}-${subsectionIndex}`
                          ] || false
                        }
                        sx={{
                          // display: 'flex',
                          // justifyContent: 'space-between',
                          // alignItems: 'center',
                          padding: 0,
                          height: '72px',
                          pr: 2,
                          '&.Mui-expanded': {
                            borderBottom: '1px solid #C9CACC'
                          }
                        }}
                      >
                        <span className="subsection-text">
                          {subsection.tittle}
                        </span>
                      </AccordionSummary>
                      <AccordionDetails style={{ padding: 0 }}>
                        <div className="subsection-table" role="rowgroup">
                          {subsection.descriptions.map(
                            (description, descIndex) => (
                              <Fragment key={descIndex}>
                                <div role="row">
                                  <div
                                    role="button"
                                    tabIndex={description.features ? 0 : -1}
                                    aria-expanded={
                                      expandedDescriptions[
                                        `${subsection.id}-${description.id}`
                                      ]
                                        ? true
                                        : false
                                    }
                                    className={`subsection-tr-section
                                         ${expandedDescriptions[
                                        `${subsection.id}-${description.id}`
                                      ]
                                        ? 'expanded'
                                        : ''
                                      }
                                            ${descIndex ===
                                        subsection.descriptions.length - 1
                                        ? 'no-border-bottom'
                                        : ''
                                      }
                                            
                                            `}
                                    style={{
                                      borderBottomRightRadius:
                                        subsectionIndex ===
                                          section.subsections.length - 1 &&
                                          descIndex ===
                                          subsection.descriptions.length - 1
                                          ? '16px'
                                          : '',
                                      borderBottomLeftRadius:
                                        subsectionIndex ===
                                          section.subsections.length - 1 &&
                                          descIndex ===
                                          subsection.descriptions.length - 1
                                          ? '16px'
                                          : ''
                                    }}
                                    key={descIndex}
                                    onKeyDown={
                                      description.features
                                        ? (e) => {
                                          if (e.key === 'Enter')
                                            handleAccordion(
                                              description.id,
                                              subsection.id
                                            );
                                        }
                                        : undefined
                                    }
                                    onClick={
                                      description.features
                                        ? () =>
                                          handleAccordion(
                                            description.id,
                                            subsection.id
                                          )
                                        : undefined
                                    }
                                  >
                                    <div
                                      style={{
                                        display: 'grid',
                                        gridTemplateColumns: '90% 10%'
                                        // position:"relative"
                                      }}
                                      role="rowheader"
                                    >
                                      <div
                                        aria-label={`Feature: ${description.description}`}
                                        className={`description-section 
                                         ${expandedDescriptions[
                                            `${subsection.id}-${description.id}`
                                          ]
                                            ? 'expanded'
                                            : ''
                                          }
                                         ${descIndex ===
                                            subsection.descriptions.length - 1
                                            ? 'no-border-bottom'
                                            : ''
                                          }
                                         `}
                                         dangerouslySetInnerHTML={{ __html: description.description }}
                                      >
                                        {/* {description.description} */}
                                      </div>
                                      {description.features &&
                                        description.features.length > 0 && (
                                          <div className="arrow-container">
                                            <img
                                              src={
                                                expandedDescriptions[
                                                  `${subsection.id}-${description.id}`
                                                ]
                                                  ? UpArrow
                                                  : DownArrow
                                              }
                                              alt={
                                                expandedDescriptions[
                                                  `${subsection.id}-${description.id}`
                                                ]
                                                  ? 'Collapse subsection'
                                                  : 'Expand subsection'
                                              }
                                              className="description-custom-accordion-icon"
                                            />
                                          </div>
                                        )}
                                    </div>
                                    <div
                                      style={{
                                        display: 'grid',
                                        gridTemplateColumns:
                                          '33.33% 33.33% 33.33%',
                                        alignItems: 'center'
                                      }}
                                      role="row"
                                    >
                                      {Array.from({ length: 3 }).map(
                                        (_, index) => {
                                          const averageStatus =
                                            description.features
                                              ? calculateAverageStatus(
                                                description.features || [],
                                                selectedPartner,
                                                index
                                              )
                                              : description[
                                              selectedPartners[index]
                                                ?.partnerLogo ??
                                              selectedPartner[index]
                                              ];
                                          return (
                                            <div
                                              role="cell"
                                              className={`icon-section
                                             ${expandedDescriptions[
                                                  `${subsection.id}-${description.id}`
                                                ]
                                                  ? 'expanded'
                                                  : ''
                                                }
                                              ${descIndex ===
                                                  subsection.descriptions.length -
                                                  1
                                                  ? 'no-border-bottom'
                                                  : ''
                                                }`}
                                              key={index}
                                            >
                                              <div className="yes-with-arrow">
                                                <span className="description-status-icon">
                                                  {averageStatus &&
                                                    getStatusIcon(
                                                      averageStatus
                                                    )}
                                                </span>
                                              </div>
                                            </div>
                                          );
                                        }
                                      )}
                                    </div>
                                  </div>
                                </div>
                                {expandedDescriptions[
                                  `${subsection.id}-${description.id}`
                                ] &&
                                  description?.features?.map(
                                    (feature, featureIndex) => (
                                      // <div role="row" key={featureIndex}>
                                      <Fragment key={featureIndex}>
                                        <div role="row">
                                          <div
                                            role="button"
                                            aria-expanded={
                                              feature['sub-features'] &&
                                                feature['sub-features'].length > 0
                                                ? true
                                                : false
                                            }
                                            key={featureIndex}
                                            className={`feature-row ${feature['sub-features'] &&
                                              feature['sub-features'].length > 0
                                              ? 'subfeature-expanded'
                                              : ''
                                              }`}
                                            tabIndex={
                                              feature['sub-features'] ? 0 : -1
                                            }
                                            onKeyDown={
                                              feature['sub-features']
                                                ? (e) => {
                                                  if (e.key === 'Enter')
                                                    handleFeatureAccordion(
                                                      feature.id
                                                    );
                                                }
                                                : undefined
                                            }
                                            onClick={
                                              feature['sub-features']
                                                ? () =>
                                                  handleFeatureAccordion(
                                                    feature.id
                                                  )
                                                : undefined
                                            }
                                          >
                                            <div
                                              role="rowheader"
                                              style={{
                                                display: 'grid',
                                                gridTemplateColumns: '90% 10%'
                                                // position:"relative"
                                              }}
                                            >
                                              <div
                                                aria-label={`Sub-feature: ${feature.feature}`}
                                                className={`feature-section ${expandedFeaturess[feature.id]
                                                  ? 'expanded'
                                                  : ''
                                                  }`}
                                              >
                                                {feature.feature}
                                              </div>
                                              {feature['sub-features'] &&
                                                feature['sub-features'].length >
                                                0 && (
                                                  <span className="arrow-container">
                                                    <img
                                                      src={
                                                        expandedFeaturess[
                                                          feature.id
                                                        ]
                                                          ? UpArrow
                                                          : DownArrow
                                                      }
                                                      alt={
                                                        expandedFeaturess[
                                                          feature.id
                                                        ]
                                                          ? 'Collapse sub-feature-section'
                                                          : 'Expand sub-feature-section'
                                                      }
                                                      className="description-custom-accordion-icon"
                                                    />
                                                  </span>
                                                )}
                                            </div>
                                            <div
                                              role="row"
                                              style={{
                                                display: 'grid',
                                                gridTemplateColumns:
                                                  '33.33% 33.33% 33.33%'
                                              }}
                                            >
                                              {Array.from({ length: 3 }).map(
                                                (_, index) => {
                                                  const featureAverageStatus =
                                                    calculateAverageStatus(
                                                      [feature],
                                                      selectedPartner,
                                                      index
                                                    );
                                                  return (
                                                    <div
                                                      role="cell"
                                                      className="icon-section feature-icon-section"
                                                      key={index}
                                                    >
                                                      <div className="yes-with-arrow">
                                                        <span className="description-status-icon">
                                                          {feature[
                                                            'sub-features'
                                                          ] &&
                                                            feature[
                                                              'sub-features'
                                                            ].length > 0
                                                            ? featureAverageStatus &&
                                                            getStatusIcon(
                                                              featureAverageStatus
                                                            )
                                                            : (selectedPartners[
                                                              index
                                                            ].partnerLogo ??
                                                              selectedPartner[
                                                              index
                                                              ]) &&
                                                            feature[
                                                            selectedPartners[
                                                              index
                                                            ].partnerLogo ??
                                                            selectedPartner[
                                                            index
                                                            ]
                                                            ] &&
                                                            getStatusIcon(
                                                              feature[
                                                              selectedPartners[
                                                                index
                                                              ]
                                                                .partnerLogo ??
                                                              selectedPartner[
                                                              index
                                                              ]
                                                              ]
                                                            )}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  );
                                                }
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        {expandedFeaturess[feature.id] &&
                                          feature['sub-features'] &&
                                          feature['sub-features'].map(
                                            (subFeature, subFeatureIndex) => (
                                              <div
                                                role="row"
                                                key={subFeatureIndex}
                                                className="sub-feature-row"
                                              >
                                                <div
                                                  className="sub-feature-section"
                                                  role="rowheader"
                                                  aria-label={`Sub-feature Type: ${subFeature['sub-feature']}`}
                                                >
                                                  {subFeature['sub-feature']}
                                                </div>
                                                <div
                                                  role="row"
                                                  style={{
                                                    display: 'grid',
                                                    gridTemplateColumns:
                                                      '33.33% 33.33% 33.33%'
                                                  }}
                                                >
                                                  {Array.from({
                                                    length: 3
                                                  }).map((_, index) => (
                                                    <div
                                                      className="icon-section sub-feature-icon-section"
                                                      key={index}
                                                      role="cell"
                                                    >
                                                      {(selectedPartners[index]
                                                        .partnerLogo ??
                                                        selectedPartner[
                                                        index
                                                        ]) &&
                                                        subFeature[
                                                        selectedPartners[
                                                          index
                                                        ].partnerLogo ??
                                                        selectedPartner[
                                                        index
                                                        ]
                                                        ] &&
                                                        getStatusIcon(
                                                          subFeature[
                                                          selectedPartners[
                                                            index
                                                          ].partnerLogo ??
                                                          selectedPartner[
                                                          index
                                                          ]
                                                          ]
                                                        )}
                                                    </div>
                                                  ))}
                                                </div>
                                              </div>
                                            )
                                          )}
                                      </Fragment>
                                      // </div>
                                    )
                                  )}
                              </Fragment>
                            )
                          )}
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                ))}
              </div>
            </Fragment>
          ))}
        </div>
      </div>
    );
  };


  const renderDesktopTable = () => {
    return (
      <table
        ref={containerRef}
        className="direct-integration-table"
        aria-label="Partners Capability Comparison"
      >
        <thead ref={headerRef} className='table-thead'>
          <tr>
            <th className="s-only" scope="col" style={{ width: '576px' }}
            ><span>
                {columnTable[0]}
              </span>
            </th>
            {Array.from({ length: 3 }).map((_, index) => (
              <th className="s-only" key={index} scope="col" style={{ textAlign: 'center' }}>
                <span>
                  {selectedPartners[index].partnerLogo || `Partner ${index + 1}`}
                </span>
              </th>
            ))}
          </tr>
          <tr>
            {columnTable.map((header, index) => {
              return (
                <td key={index}
                  className="table-header"
                >
                  <div className="header-content">
                    {index === 0 ? (
                      <span aria-hidden="true">{header}</span>
                    ) : (
                      <span aria-hidden="true">
                        {selectedPartners[index - 1].partnerURL ? (
                          compPartner.find(
                            (partner) => partner.name === selectedPartners[index - 1].partnerURL
                          )?.isText ? (
                            <span>{selectedPartners[index - 1].partnerURL}</span>
                          ) : (
                            <img
                              src={
                                compPartner.find(
                                  (partner) =>
                                    partner.name === selectedPartners[index - 1].partnerURL
                                )?.name
                              }
                              alt={selectedPartners[index - 1].partnerURL}
                              aria-hidden="true"
                              className="partner-image"
                            />
                          )
                        ) : (
                          header
                        )}
                      </span>
                    )}
                    {index > 0 && (
                      <button
                        type="button"
                        className="close-icon"
                        aria-label={`Remove ${selectedPartners[index - 1].partnerLogo || selectedPartners[index - 1].partnerURL || `Partner ${index}`}`}
                        onClick={() => {
                          const updatedPartners = [...selectedPartners];
                          const partnerToRemove = updatedPartners[index - 1].partnerURL
                          updatedPartners[index - 1].partnerURL = '';
                          updatedPartners[index - 1].partnerLogo = '';
                          setSelectedPartners(updatedPartners);
                          setResetPartner(partnerToRemove);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            const updatedPartners = [...selectedPartners];
                            const partnerToRemove = updatedPartners[index - 1].partnerURL
                            updatedPartners[index - 1].partnerURL = '';
                            updatedPartners[index - 1].partnerLogo = '';
                            setSelectedPartners(updatedPartners);
                            setResetPartner(partnerToRemove);
                          }
                        }}
                      >
                        <img
                          src={CloseIcon}
                          alt=""
                          aria-hidden="true"
                        />
                      </button>
                    )
                    }
                  </div>
                </td>
              );
            })}
          </tr>
        </thead>
        <tbody>
          <>
            <tr>
              <th className="body-section body-row" scope="col">
                <div className="collapse-expand">
                  <h4 style={{ margin: 0, fontWeight: 'unset' }}>
                    <button
                      className="expand-collapse-container"
                      onClick={toggleExpandCollapse}
                      aria-expanded={isExpanded}
                      aria-label={isExpanded ? 'Collapse all' : 'Expand all'}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          toggleExpandCollapse();
                        }
                      }}
                    >
                      <span>
                        {isExpanded ? column[0].collapse : column[0].expand}
                      </span>
                      <img
                        src={ChevronDown}
                        alt={isExpanded ? 'Collapse all' : 'Expand all'}
                        className="arrow-icon"
                        aria-hidden="true"
                      />
                    </button>
                  </h4>
                </div>
              </th>
              {Array.from({ length: 3 }).map((_, index) => (
                <td className="body-section">
                  <FormControl fullWidth>
                    <div
                      className={`native-select-root ${selectedPartner[index] ? 'has-selection' : ''}`}
                    >
                      <div className="search-select-container">
                        <Select
                          autoComplete="off"
                          variant="standard"
                          SelectDisplayProps={{
                            'aria-label': selectedPartners[index].partnerLogo
                              ? `Change partner: ${selectedPartners[index].partnerLogo}`
                              : `Select partner for column ${index + 1}`,
                            role: 'button',
                            'aria-haspopup': 'dialog'
                          }}
                          ref={selectRefs[index]}
                          displayEmpty
                          value={
                            selectedPartners[index].partnerLogo
                              ? handleSelect(index)
                              : ''
                          }
                          onChange={(event) => {
                            if (event.target.value !== undefined) {
                              handlePartnerChange(event, index);
                              handleDropdownToggle(index, false);
                            }
                          }}
                          onKeyDown={(e) => handleSelectKeyDown(e, index)}
                          open={openDropdown[index]}
                          onClose={() => {
                            handleDropdownToggle(index, false);
                            setSearchTerm('');
                            setHighlightedIndex(prev => {
                              const newState = [...prev];
                              newState[index] = -1;
                              return newState;
                            });
                          }}
                          onOpen={() => {
                            handleDropdownToggle(index, true);
                            setHighlightedIndex(prev => {
                              const newState = [...prev];
                              newState[index] = -1;
                              return newState;
                            });
                          }}
                          sx={{
                            width: '100%',
                            '.MuiSelect-root .MuiInputBase-root': {
                              width: '100% !important'
                            },
                            // position:'relative'
                            '& .MuiSelect-icon': {
                              display: 'none'
                            },
                            '&:before': {
                              borderBottom: 'none'
                            },
                            '&:after': {
                              borderBottom: 'none'
                            },
                            '&:hover:not(.Mui-disabled):before': {
                              borderBottom: 'none'
                            },
                            '& .MuiSelect-select': {
                              backgroundColor: 'transparent !important'
                            },
                            '& .MuiMenu-list, & .MuiList-padding': {
                              paddingTop: '0px'
                            }
                          }}
                          renderValue={(selected) => {
                            if (!selected) {
                              return (
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row'
                                  }}
                                  tabIndex={0}
                                >
                                  <img
                                    src={SearchIcon}
                                    alt="search icon"
                                    className="search-icon"
                                    aria-hidden="true"
                                  />
                                  <div
                                    style={{
                                      position: 'relative',
                                      bottom: '-4px',
                                      marginLeft: '10px',
                                      fontWeight: 600,
                                      fontSize: '15px',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                      width: isMobile ? '25px' : '100%'
                                    }}
                                  >
                                    {column[0].dropdownText}
                                  </div>
                                </div>
                              );
                            }
                            return (
                              <div
                                style={{ display: 'flex', flexDirection: 'row' }}
                              // tabIndex={0}
                              >
                                <img
                                  src={SearchIcon}
                                  alt="search icon"
                                  className="search-icon"
                                  aria-hidden="true"
                                />
                                <div
                                  style={{
                                    position: 'relative',
                                    bottom: '-4px',
                                    marginLeft: '10px',
                                    fontWeight: 600,
                                    fontSize: '15px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    width: isMobile ? '25px' : '100%'
                                  }}
                                >
                                  {selectedPartners[index].partnerLogo}
                                </div>
                              </div>
                            );
                          }}
                          MenuProps={{
                            // disablePortal: true,

                            disableScrollLock: true,
                            anchorOrigin: {
                              vertical: 'top',
                              horizontal: 'left'
                            },
                            transformOrigin: {
                              vertical: 'top',
                              horizontal: 'left'
                            },
                            PaperProps: {
                              sx: {
                                '&::-webkit-scrollbar': {
                                  display: 'none'
                                },
                                msOverflowStyle: 'none', // IE and Edge
                                scrollbarWidth: 'none', // Firefox
                                '& .MuiMenu-list, & .MuiList-padding': {
                                  paddingTop: '0px',
                                  paddingBottom: '0px'
                                }
                              },
                              style: {
                                maxHeight: 260,
                                overflowY: 'auto',
                                width: '350px',
                                borderRadius: '14px 14px 14px 14px',
                                paddingTop: '0px',
                                marginTop: '-21px',
                                marginLeft: '-17px'
                              },
                              //ref: dropdownDialogRefs[index],
                              role: 'dialog',
                              'aria-modal': 'true',
                              'aria-label': selectedPartners[index].partnerLogo
                                ? `Change partner: ${selectedPartners[index].partnerLogo}`
                                : `Select partner for column ${index + 1}`
                            }
                          }}
                        >
                          <div
                            style={{
                              padding: '30px',
                              backgroundColor: '#F1F7FB',
                              borderBottom: '1px solid #1460AA',
                              top: '0px',
                              zIndex: 1,
                              position: 'sticky'
                            }}
                          >
                            <TextField
                              id="input-with-icon-textfield"
                              variant="standard"
                              value={searchTerm}
                              helperText={column[0].helperText_1}
                              inputRef={textFieldRefs[index]}
                              autoFocus
                              inputProps={{
                                'aria-label': `Search partner for column ${index + 1}`,
                                'aria-autocomplete': 'list',
                                'aria-controls': `partner-suggestion-list-${index}`
                              }}
                              sx={{
                                width: '100%',
                                '& input': {
                                  fontSize: '16px',
                                  fontWeight: 600,
                                  marginBottom: '7px'
                                }
                              }}
                              onChange={(e) => setSearchTerm(e.target.value)}
                              onKeyDown={(e) => handleTextFieldKeyDown(e, index)}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <img
                                      src={SearchIcon}
                                      alt="search icon"
                                      // className="search-icon"
                                      aria-hidden="true"
                                      style={{
                                        width: '25px',
                                        height: '25px',
                                        margin: '0px 10px 10px 0px'
                                      }}
                                    />
                                  </InputAdornment>
                                )
                              }}
                            />
                          </div>
                          {getFilteredPartners(index, searchTerm).map(
                            (partner, partnerIndex, arr) => (
                              <MenuItem
                                className="dropdown-section"
                                key={partnerIndex}
                                value={partner.id}
                                role="option"
                                aria-label={partner.partner_name}
                                id={`partner-option-${index}-${partnerIndex}`}
                                ref={
                                  partnerIndex === 0
                                    ? firstMenuItemRefs[index]
                                    : null
                                }
                                onKeyDown={(e) => {
                                  if (partnerIndex === 0 && e.key === 'ArrowUp') {
                                    e.preventDefault();
                                    textFieldRefs[index].current?.focus();
                                  }
                                  else if(e.key === 'Tab'){
                                    e.preventDefault();
                                    e.stopPropagation();
                                    textFieldRefs[index].current?.focus();
                                  }
                                  else if (e.key === 'Enter') {
                                    e.preventDefault();
                                    handlePartnerChange({ target: { value: partner.id } }, index);
                                    handleDropdownToggle(index, false);
                                  }

                                }
                                }
                                onMouseEnter={() => handleMenuItemHover(partnerIndex, index)}
                                tabIndex={0} // Ensure it's focusable
                                aria-selected={
                                  selectedPartners[index].partnerLogo
                                    ? handleSelect(index) ===
                                    partner.id.toString()
                                    : false
                                }
                                sx={{
                                  height: '50px',
                                  '&.Mui-selected': {
                                    backgroundColor: '#EFF0F2'
                                  }
                                }}
                              >
                                {partner.partner_name}
                              </MenuItem>
                            )
                          )}
                        </Select>
                      </div>
                      <div>
                        <img
                          className="arrow-icon"
                          src={ArrowIcon}
                          alt=""
                          aria-hidden="true"
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleDropdownToggle(index, true)}
                        />
                      </div>
                    </div>
                    <FormHelperText className="custom-helper-text">
                      {selectedPartner[index] ||
                        selectedPartners[index].partnerLogo ? (
                        <span> {column[0].helperText_1} </span>
                      ) : (
                        <span> {column[0].helperText_2} </span>
                      )}
                    </FormHelperText>
                  </FormControl>
                </td>
              ))}
            </tr>
            {section.map((section, sectionIndex) => (
              <Fragment key={sectionIndex} >
                <tr style={{ height: '72px' }}>
                  <th
                    scope="row"
                    className="section-head"
                    colSpan={columnTable.length}
                    id={`section-${sectionIndex}`}
                  >
                    {section.title}
                  </th>
                </tr>
                {section.subsections.map((subsection, subsectionIndex) => (
                  <Fragment key={subsectionIndex}>
                    <tr style={{ height: '72px' }}>
                      <td className="custom-subsection" colSpan={columnTable.length}>
                        <h5 style={{
                          margin: 0,
                          fontWeight: 'unset',
                        }}>
                          <Accordion
                            // key={subsectionIndex}
                            expanded={expandedSubsections[`${sectionIndex}-${subsectionIndex}`] || false}
                            onChange={() =>
                              setExpandedSubsections((prevState) => ({
                                ...prevState,
                                [`${sectionIndex}-${subsectionIndex}`]: !prevState[`${sectionIndex}-${subsectionIndex}`],
                              }))}
                            aria-controls={`panel${subsectionIndex}-content`}
                            id={`panel${subsectionIndex}-header`}
                            aria-expanded={expandedSubsections[`${sectionIndex}-${subsectionIndex}`] || false}
                            sx={{
                              backgroundColor: expandedSubsections[`${sectionIndex}-${subsectionIndex}`] ? '#ddecf5' : '#f1f7fa',
                              //borderBottom: section.subsections.length - 1 === subsectionIndex ? 'none' : '1px solid #C9CACC',
                              boxShadow: 'none',
                              '&.Mui-expanded': {
                                padding: 0,
                                margin: 0,
                              },
                            }}
                          >
                            <AccordionSummary
                              expandIcon={
                                <img
                                  src={DownArrow}
                                  alt="Expand subsection"
                                  className="custom-accordion-icon"
                                />
                              }
                              aria-controls={`panel${subsectionIndex}-content`}
                              id={`panel${subsectionIndex}-header`}
                              aria-expanded={expandedSubsections[`${sectionIndex}-${subsectionIndex}`] || false}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: 0,
                                height: '72px',
                                pr: 2
                              }}
                            >
                              <span className="subsection-text">{subsection.tittle}</span>
                            </AccordionSummary>
                            {/* <AccordionDetails style={{ padding: 0 }}> */}
                            {/* <table className="subsection-table">
                                <tbody> */}
                            {/* {subsection.descriptions.map((description, descIndex) => (
                                <Fragment key={descIndex}>
                                  <tr className={`subsection-tr-section
                                         ${expandedDescriptions[`${subsection.id}-${description.id}`] ?
                                      'expanded' : ''}
                                            ${descIndex === subsection.descriptions.length - 1
                                      ? 'no-border-bottom'
                                      : ''
                                    }
                                            `}
                                    key={descIndex}
                                    onClick={description.features ?
                                      () => handleAccordion(description.id, subsection.id) : undefined}
                                  >
                                    <th scope='row' className={`description-section 
                                         ${expandedDescriptions[`${subsection.id}-${description.id}`] ?
                                        'expanded' : ''}
                                         ${descIndex === subsection.descriptions.length - 1
                                        ? 'no-border-bottom'
                                        : ''
                                      }
                                         `}
                                    >
                                      {description.description}</th>
                                    {Array.from({ length: 3 }).map((_, index) => {
                                      const averageStatus = description.features ?
                                        calculateAverageStatus(
                                          description.features || [],
                                          selectedPartner,
                                          index
                                        ) : description[selectedPartners[index]?.partnerLogo ??
                                        selectedPartner[index]];
                                      return (
                                        <td className={`icon-section
                                             ${expandedDescriptions[`${subsection.id}-${description.id}`] ?
                                            'expanded' : ''}
                                              ${descIndex === subsection.descriptions.length - 1
                                            ? 'no-border-bottom'
                                            : ''
                                          }`} key={index}>
                                          <div className="yes-with-arrow">
                                            <span className="description-status-icon">{averageStatus && getStatusIcon(averageStatus)}</span>
                                            {index === 2 && description.features && description.features.length > 0 && (
                                              <span className="arrow-container">
                                                <img
                                                  src={expandedDescriptions[`${subsection.id}-${description.id}`] ? UpArrow : DownArrow}
                                                  alt={expandedDescriptions[`${subsection.id}-${description.id}`] ? "Collapse sunsection" : "Expand subsection"}
                                                  className="description-custom-accordion-icon"
                                                /></span>
                                            )}
                                          </div>
                                        </td>
                                      );
                                    })}
                                  </tr>
                                  {expandedDescriptions[`${subsection.id}-${description.id}`] && description?.features?.map((feature, featureIndex) => (
                                    <Fragment key={featureIndex}>
                                      <tr key={featureIndex}
                                        className="feature-row"
                                        onClick={feature['sub-features'] ? () => handleFeatureAccordion(feature.id) : undefined}
                                      >
                                        <th
                                          scope='row'
                                          className={`feature-section ${expandedFeaturess[feature.id] ? 'expanded' : ''}`}
                                        >{feature.feature}</th>
                                        {Array.from({ length: 3 }).map((_, index) => {
                                          const featureAverageStatus = calculateAverageStatus(
                                            [feature],
                                            selectedPartner,
                                            index
                                          );
                                          return (
                                            <td className="icon-section feature-icon-section" key={index}>
                                              <div className="yes-with-arrow">
                                                <span className="description-status-icon">
                                                  {feature['sub-features'] && feature['sub-features'].length > 0 ?
                                                    featureAverageStatus && getStatusIcon(featureAverageStatus) :
                                                    (selectedPartners[index].partnerLogo ?? selectedPartner[index]) &&
                                                    feature[selectedPartners[index].partnerLogo ?? selectedPartner[index]] &&
                                                    getStatusIcon(feature[selectedPartners[index].partnerLogo ?? selectedPartner[index]])
                                                  }</span>
                                                {index === 2 && feature['sub-features'] && feature['sub-features'].length > 0 && (
                                                  <span className="arrow-container">
                                                    <img
                                                      src={expandedFeaturess[feature.id] ? UpArrow : DownArrow}
                                                      alt={expandedFeaturess[feature.id] ? "Collapse sub-feature-section" : "Expand sub-feature-section"}
                                                      className="description-custom-accordion-icon"
                                                    /></span>
                                                )}
                                              </div>
                                            </td>
                                          );
                                        })}
                                      </tr>
                                      {
                                        expandedFeaturess[feature.id] && feature['sub-features'] &&
                                        feature['sub-features'].map((subFeature, subFeatureIndex) => (
                                          <tr key={subFeatureIndex} className="sub-feature-row">
                                            <th
                                              scope='row'
                                              className="sub-feature-section">
                                              {subFeature['sub-feature']}
                                            </th>
                                            {
                                              Array.from({ length: 3 }).map((_, index) => (
                                                <td className="icon-section sub-feature-icon-section" key={index}>
                                                  {(selectedPartners[index].partnerLogo ?? selectedPartner[index]) &&
                                                    subFeature[selectedPartners[index].partnerLogo ?? selectedPartner[index]] &&
                                                    getStatusIcon(subFeature[selectedPartners[index].partnerLogo ?? selectedPartner[index]])
                                                  }

                                                </td>
                                              ))
                                            }
                                          </tr>
                                        ))
                                      }
                                    </Fragment>
                                  ))
                                  }
                                </Fragment>

                              ))} */}
                            {/* </tbody>
                              </table> */}
                            {/* </AccordionDetails> */}
                          </Accordion>

                        </h5>
                      </td>
                    </tr>
                    {expandedSubsections[`${sectionIndex}-${subsectionIndex}`] &&
                      subsection.descriptions.map((description, descIndex) => (
                        <Fragment key={descIndex}>
                          <tr className={`subsection-tr-section
                                         ${expandedDescriptions[`${subsection.id}-${description.id}`] ?
                              'expanded' : ''}
                                            ${descIndex === subsection.descriptions.length - 1
                              ? 'no-border-bottom'
                              : ''
                            }
                                            `}
                            key={descIndex}
                            onClick={description.features ?
                              () => handleAccordion(description.id, subsection.id) : undefined}
                          >
                            <th scope='row' className={`description-section 
                                         ${expandedDescriptions[`${subsection.id}-${description.id}`] ?
                                'expanded' : ''}
                                         ${descIndex === subsection.descriptions.length - 1
                                ? 'no-border-bottom'
                                : ''
                              }
                                         `}
                              dangerouslySetInnerHTML={{ __html: description.description }}
                            >
                            </th>
                            {Array.from({ length: 3 }).map((_, index) => {
                              const averageStatus = description.features ?
                                calculateAverageStatus(
                                  description.features || [],
                                  selectedPartner,
                                  index
                                ) : description[selectedPartners[index]?.partnerLogo ??
                                selectedPartner[index]];
                              return (
                                <td className={`icon-section
                                             ${expandedDescriptions[`${subsection.id}-${description.id}`] ?
                                    'expanded' : ''}
                                              ${descIndex === subsection.descriptions.length - 1
                                    ? 'no-border-bottom'
                                    : ''
                                  }`} key={index}>
                                  <div className="yes-with-arrow">
                                    <span className="description-status-icon">{getStatusIcon(averageStatus)}</span>
                                    {index === 2 && description.features && description.features.length > 0 && (
                                      <span className="arrow-container">
                                        <img
                                          src={expandedDescriptions[`${subsection.id}-${description.id}`] ? UpArrow : DownArrow}
                                          alt={expandedDescriptions[`${subsection.id}-${description.id}`] ? "Collapse subsection" : "Expand subsection"}
                                          className="description-custom-accordion-icon"
                                        /></span>
                                    )}
                                  </div>
                                </td>
                              );
                            })}
                          </tr>
                          {expandedDescriptions[`${subsection.id}-${description.id}`] && description?.features?.map((feature, featureIndex) => (
                            <Fragment key={featureIndex}>
                              <tr key={featureIndex}
                                className="feature-row"
                                onClick={feature['sub-features'] ? () => handleFeatureAccordion(feature.id) : undefined}
                              >
                                <th
                                  scope='row'
                                  className={`feature-section ${expandedFeaturess[feature.id] ? 'expanded' : ''}`}
                                >{feature.feature}</th>
                                {Array.from({ length: 3 }).map((_, index) => {
                                  const featureAverageStatus = calculateAverageStatus(
                                    [feature],
                                    selectedPartner,
                                    index
                                  );
                                  return (
                                    <td className="icon-section feature-icon-section" key={index}>
                                      <div className="yes-with-arrow">
                                        <span className="description-status-icon">
                                          {feature['sub-features'] && feature['sub-features'].length > 0 ?
                                            featureAverageStatus && getStatusIcon(featureAverageStatus) :
                                            (selectedPartners[index].partnerLogo ?? selectedPartner[index]) &&
                                            feature[selectedPartners[index].partnerLogo ?? selectedPartner[index]] &&
                                            getStatusIcon(feature[selectedPartners[index].partnerLogo ?? selectedPartner[index]])
                                          }</span>
                                        {index === 2 && feature['sub-features'] && feature['sub-features'].length > 0 && (
                                          <span className="arrow-container">
                                            <img
                                              src={expandedFeaturess[feature.id] ? UpArrow : DownArrow}
                                              alt={expandedFeaturess[feature.id] ? "Collapse sub-feature-section" : "Expand sub-feature-section"}
                                              className="description-custom-accordion-icon"
                                            /></span>
                                        )}
                                      </div>
                                    </td>
                                  );
                                })}
                              </tr>
                              {
                                expandedFeaturess[feature.id] && feature['sub-features'] &&
                                feature['sub-features'].map((subFeature, subFeatureIndex) => (
                                  <tr key={subFeatureIndex} className="sub-feature-row">
                                    <th
                                      scope='row'
                                      className="sub-feature-section">
                                      {subFeature['sub-feature']}
                                    </th>
                                    {
                                      Array.from({ length: 3 }).map((_, index) => (
                                        <td className="icon-section sub-feature-icon-section" key={index}>
                                          {(selectedPartners[index].partnerLogo ?? selectedPartner[index]) &&
                                            subFeature[selectedPartners[index].partnerLogo ?? selectedPartner[index]] &&
                                            getStatusIcon(subFeature[selectedPartners[index].partnerLogo ?? selectedPartner[index]])
                                          }

                                        </td>
                                      ))
                                    }
                                  </tr>
                                ))
                              }
                            </Fragment>
                          ))
                          }
                        </Fragment>
                      ))}
                  </Fragment>
                ))
                }
              </Fragment>
            ))}
          </>
        </tbody>
      </table>
    );
  };

  const renderFooter = () => {
    const footerData = column[0].footer[0].entries;
    const roadMapLink = column[0].footer[1].links[0];
    return (
      <div className="infoAndLinksBar">
        <div className="footer-status-icons">
          {footerData.map((item, index) => {
            return (
              <div key={index} className="footer-status-item">
                <span className="footer-status-icon" aria-hidden="true">
                  {getStatusIcon(item.text)}
                </span>
                <span aria-label={item.text} className="footer-status-text">
                  {item.text}
                </span>
              </div>
            );
          })}
          <div className="footer-roadmap-link">
            <p>
              {column[0].footer[0].text_1} {''}
              <a href={`/${i18n.language}/api/${roadMapLink.path}`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Roadmap link: ${roadMapLink.text}`}
              >
                {roadMapLink.text}
              </a> {''}
              {column[0].footer[0].text_2} {''}
            </p>
          </div>
        </div>
      </div>
    );
  };

  // const renderMobileTable = () => {
  //   return (
  //     <div className="direct-integration-table-mobile">
  //       {sections.map((section, sectionIndex) => {
  //         return (
  //           <Fragment key={sectionIndex}>
  //             <div className="container-header">{section.title}</div>
  //             {section.subsections.map((subsection, subsectionIndex) => {
  //               return (
  //                 <Fragment key={`${sectionIndex}-${subsectionIndex}`}>
  //                   <div className="container-subheader">
  //                     {subsection.title}
  //                   </div>
  //                   {subsection.features.map((feature, featureIndex) => {
  //                     return (
  //                       <div
  //                         className="subsection"
  //                         key={`${sectionIndex}-${subsectionIndex}-${featureIndex}`}
  //                       >
  //                         {columns.slice(1).map((column, columnIndex) => {
  //                           return (
  //                             <div
  //                               className="feature"
  //                               key={`${sectionIndex}-${subsectionIndex}-${featureIndex}-${columnIndex}`}
  //                             >
  //                               <p className="feature-header">{column}</p>
  //                               {columnIndex === 0
  //                                 ? feature.description
  //                                 : columnIndex === 1
  //                                   ? feature.air_canada_ndc_api
  //                                   : feature.gds_edifact}
  //                             </div>
  //                           );
  //                         })}
  //                       </div>
  //                     );
  //                   })}
  //                 </Fragment>
  //               );
  //             })}
  //           </Fragment>
  //         );
  //       })}
  //     </div>
  //   );
  // };

  const renderPopup = () => {
    if (!isInfoBoxOpen) return null;
    const popupContent = column[0].popUp_box;
    return (
      <div
        className={`info-popup ${language === 'fr' ? 'fr' : ''}`}
        role="dialog"
        aria-labelledby="popup-heading"
        aria-describedby="popup-paragraph"
        aria-modal="true"
        onMouseEnter={() => setIsInfoBoxOpen(true)}
        onMouseLeave={() => setIsInfoBoxOpen(false)}
      >
        <div className="popup-content">
          <h4
            id="popup-heading"
            style={{
              fontWeight: '700',
              fontSize: '16px',
              lineHeight: '20px',
              letterSpacing: '0px',
              color: '#000000'
            }}
          >
            {popupContent.heading}
          </h4>
          <p
            id="popup-paragraph"
            dangerouslySetInnerHTML={{ __html: popupContent.paragraph }}
          />
        </div>
        <div className="popup-close">
          <IconButton
            onClick={toggleCloseInfoBox}
            aria-label="Close popup"
            className="close-icon"
          >
            <img src={CloseIcon} alt="" aria-hidden="true" />
          </IconButton>
        </div>
      </div>
    );
  };

  const handleResetToDefault = () => {
    setResetPartner('reset');
    announceTableUpdate();
  };

  useEffect(() => {
    if (resetPartner === 'reset') {
      setResetPartner(null);
    }
  }, [resetPartner]);

  return (
    <div className="connection-options-body-content">
      <PartnerSelection
        partner={compPartner}
        onPartnerChange={handlePartnerSelection}
        resetPartner={resetPartner}
        parentSelectedPartners={selectedPartners}
      />
      <div
        aria-live="polite"
        aria-atomic="true"
        style={{
          position: 'absolute',
          left: '-9999px',
          height: '1px',
          width: '1px',
          overflow: 'hidden'
        }}
      >
        {announcementMessage}
      </div>
      <div
        className="content-spacing"
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'end' : 'center',
          gap: isMobile ? '10px' : '40px'
        }}
        role="toolbar"
        aria-label="Table actions"
      >
        {/* <Button
          className="top-content"
          aria-label={column[0].download}
          onClick={() => console.log('Download icon clicked')}
          // aria-label={column[0].download}
          // aria-hidden="true"
          // className="download-icon"
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              console.log('Download icon clicked');
            }
          }}
        >
          <img
            src={DownloadIcon}
            alt=""
            aria-hidden="true"
            style={{ marginRight: '8px' }}
          />

          <span
            className="download-text"
            style={{
              color: '#1460AA',
              fontWeight: '700',
              fontSize: '16px',
              lineHeight: '20px',
              letterSpacing: '0px',
              textTransform: 'none'
            }}
          >
            {column[0].download}
          </span>
          <IconButton
            // onClick={toggleInfoBox}
            aria-label="More information"
            className="info-icon"
            style={{ color: '#717173' }}
            onMouseEnter={() => setIsInfoBoxOpen(true)}
            onMouseLeave={() => setIsInfoBoxOpen(false)}
          >
            <img src={InfoIcon} alt="" aria-hidden="true" />
          </IconButton>
        </Button> */}
        <Button
          className="reset-button"
          onClick={handleResetToDefault}
          aria-label={column[0].reset}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleResetToDefault();
            }
          }}
        >
          <span>{column[0].reset}</span>
        </Button>
      </div>
      {renderPopup()}
      {/* {renderDesktopTable()} */}
      {/* <h3>{data[0].title}</h3> */}
      {isTablet ? renderTabletTable() : renderDesktopTable()}
      {renderFooter()}
    </div>
  );
};

export default DirectIntegrationTable;
